export { default } from './RightPanel';
